<div class="custom-header">
  <div></div>
  <span class="custom-header-label">{{periodLabel | titlecase}}</span>
  <button mat-icon-button class="_right" (click)="clicked()">
    <one-icon name="chevron-forward-outline"></one-icon>
  </button>
</div>
